import { render, staticRenderFns } from "./FormatSelect.vue?vue&type=template&id=505498c8"
import script from "./FormatSelect.vue?vue&type=script&lang=js"
export * from "./FormatSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports